export enum ProductKeys {
  SECURE_WORKLOAD = 'secure-workload',
  XDR = 'xdr',
  SASE = 'sase',
}

export enum ProductPermissionStatus {
  ADDED = 'added',
  DELETED = 'deleted',
  UNCHANGED = 'unchanged',
}
